










































































































import CalendeskWarningMessage from '@/components/shared/CalendeskWarningMessage.vue'
import mixins from 'vue-typed-mixins'
import DraftElement from '@/calendesk/sections/section/mixins/DraftElement'
import { EventBus } from '@/calendesk/plugins/eventBus'

export default mixins(DraftElement).extend({
  name: 'TwoFAExtraVerification',
  components: { CalendeskWarningMessage },
  data () {
    return {
      showDialog: false,
      sessionData: null as any,
      code: null as string | null,
      recoveryCode: null as string | null,
      useRecoveryCode: false,
      resolveCallback: null as Function | null,
      rejectCallback: null as Function | null,
      isVerifyingCode: false,
      errorMessage: null as string | null
    }
  },
  created () {
    EventBus.$on(
      '2FA_EXTRA_VERIFICATION',
      this.handle2faExtraVerificationEvent
    )
    EventBus.$on('2FA_CLOSE_DIALOG', this.closeDialogOnSessionExpired)
  },
  beforeDestroy () {
    EventBus.$off(
      '2FA_EXTRA_VERIFICATION',
      this.handle2faExtraVerificationEvent
    )
    EventBus.$off('2FA_CLOSE_DIALOG', this.closeDialogOnSessionExpired)
  },
  methods: {
    verify2faCode () {
      this.isVerifyingCode = true
      this.errorMessage = null

      const codeToUse = this.useRecoveryCode ? this.recoveryCode : this.code

      const errorCallback = () => {
        this.isVerifyingCode = false
        this.code = null
        this.recoveryCode = null
      }

      const successCallback = () => {
        this.closeDialogSuccess()
      }

      if (this.resolveCallback) {
        this.resolveCallback(codeToUse, errorCallback, successCallback)
      }
    },
    closeDialog () {
      this.showDialog = false
      if (this.rejectCallback) {
        this.rejectCallback(new Error('2FA_VERIFICATION_CANCELLED'))
      }
      this.clearData()
    },
    closeDialogSuccess () {
      this.showDialog = false
      this.clearData()
    },
    handle2faExtraVerificationEvent (resolve: Function, reject: Function, sessionData: any) {
      this.showDialog = true
      this.sessionData = sessionData
      this.resolveCallback = resolve
      this.rejectCallback = reject
    },
    toggleRecoveryMode () {
      this.useRecoveryCode = !this.useRecoveryCode
      this.code = null
      this.recoveryCode = null
      this.errorMessage = null
    },
    clearData () {
      this.sessionData = null
      this.code = null
      this.recoveryCode = null
      this.useRecoveryCode = false
      this.resolveCallback = null
      this.rejectCallback = null
      this.isVerifyingCode = false
      this.errorMessage = null
    },
    closeDialogOnSessionExpired () {
      this.showDialog = false
      this.clearData()
    }
  }
})
